import modal from './modal.html';

/* @ngInject */
export default function ($scope, AuthService, $timeout, LayoutService, Roster, toastr, ReportsService, moment, DataTablesService, $rootScope, $uibModal, RosterSettings) {
	LayoutService.setTitle('Roster');
	LayoutService.getPageHeader()
	             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');
	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'supportWorker.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       'supportWorker.roster.root',
			             displayName: 'Roster',
		             },
	             ]);

	$scope.loading = true;
	$scope.moment  = moment;

	$scope.activeTabs = {
		all: 0,
	};

	$scope.$watch('activeTabs.all', () => {
		$timeout(() => {
			$rootScope.$broadcast('sidebar.triggerResize');
		}, 100);
	});

	$scope.refresh = () => {
		$scope.loading = true;

		RosterSettings.getList()
		              .then((rosterSettings) => {
			              const cutoff = rosterSettings[0].cutoff;

			              const week      = ReportsService.businessWeek();
			              const fortnight = ReportsService.visitFortnight(cutoff);

			              $scope.now                   = moment();
			              $scope.weekStart             = week.start;
			              $scope.weekEnd               = week.end;
			              $scope.currentFortnightStart = fortnight.start;
			              $scope.currentFortnightEnd   = fortnight.end;

			              Roster.getList({
				              start: moment.min($scope.now, $scope.weekStart, $scope.currentFortnightStart)
				                           .format(),
				              end:   moment.max($scope.now, $scope.weekEnd, $scope.currentFortnightEnd)
				                           .format(),
			              })
			                    .then((roster) => {
				                    $scope.roster = roster;

				                    $scope.dataTable = DataTablesService.configure({
					                    title: 'Roster',
				                    }, {
					                    order: [
						                    [
							                    5,
							                    'asc',
						                    ],
					                    ],
				                    });

				                    $scope.visitsThisWeek = $scope.roster.filter((visit) => {
					                    const startTime = moment(visit['Start Time']);

					                    return startTime.isBetween($scope.weekStart, $scope.weekEnd, null, '[)');
				                    });

				                    $scope.visitsThisFortnight = $scope.roster.filter((visit) => {
					                    const startTime = moment(visit['Start Time']);

					                    return startTime.isBetween($scope.currentFortnightStart, $scope.currentFortnightEnd, null, '[)');
				                    });

				                    $scope.loading = false;
			                    })
			                    .catch((error) => {
				                    toastr.clear();
				                    toastr.error('There was an error while loading the roster, please try again.', 'Error');

				                    $scope.loading = false;
			                    });
		              });
	};

	$scope.openModal = (visitId) => {
		$uibModal.open({
			animation:                  true,
			template:                   modal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance, moment) => {
				$scope.moment = moment;

				$scope.modalCompletedOptions = [
					{
						key:   true,
						value: 'Yes',
					},
					{
						key:   false,
						value: 'No',
					},
				];

				$scope.modalVisit = $scope.roster.find((visit) => {
					return visit['Visit Id'] === visitId;
				});

				$scope.modalVisitDetails = {
					completed:  $scope.modalVisit['Extra Completed'],
					kilometres: $scope.modalVisit['Extra Kilometres'],
					comments:   $scope.modalVisit['Extra Comments'],
				};

				$scope.modalCancel = () => {
					$uibModalInstance.close();
				};

				$scope.modalConfirm = () => {
					Roster.one(visitId)
					      .customPUT($scope.modalVisitDetails)
					      .then((roster) => {
						      toastr.clear();
						      toastr.success('The visit was successfully updated.', 'Saved');

						      $uibModalInstance.close();

						      $scope.refresh();
					      })
					      .catch((error) => {
						      toastr.clear();
						      toastr.error('There was an error while saving the visit, please try again.', 'Error');
					      });
				};
			},
		});
	};

	LayoutService.getPageHeader()
	             .onClicked($scope.refresh);

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/supportWorker/roster/root/controller.js